// extracted by mini-css-extract-plugin
export var active = "_al-a";
export var activeIndicator = "_al-8";
export var animate = "_al-9";
export var disabled = "_al-b";
export var fullWidth = "_al-2";
export var lg = "_al-7";
export var md = "_al-6";
export var redoButtonTabGroup = "_al-0";
export var sm = "_al-5";
export var tabButton = "_al-3";
export var tabButtonsContainer = "_al-1";
export var xs = "_al-4";